<style lang="scss" scoped>
.banner-container {
  position: relative;
  height: 750px;
  overflow: hidden;
  .gradual .vague {
    filter: blur(2px);
  }

  .gradual {
    img {
      &.gradual-hide_img {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        animation: origin 1s ease;
      }
    }
  }

  @keyframes origin {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 0;
    }
  }
  img {
    display: block;
    width: 100%;
    height: 100vw;
    object-fit: cover;
    &:not([src]) + p {
      opacity: 0;
    }
    &.image-item-pc {
      pointer-events: none;
    }
  }

  .test {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .z-swipe {
    /deep/ .z-swipe__check-more {
      z-index: 99999999;
      img {
        width: 24px;
        height: 24px;
        margin-left: 20px !important;
      }
      .text {
        width: 20px;
        height: 280px;
        margin-left: 12px !important;
        color: #999999;
        font-weight: 300;
        font-size: 20px;
        font-family: PingFangSC-Light, PingFang SC;
        line-height: 28px;
      }
    }
    /deep/ .z-swipe__indicators {
      display: none;
    }
  }

  .custom-indicator {
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 99;
    display: flex;
    height: 48px;
    margin-bottom: 24px;
    font-weight: 300;
    font-size: 20px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 24px;
    transform: translateX(-50%);

    span {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 20px;
      color: #999999;
      font-weight: 300;
      font-family: PingFangSC-Light, PingFang SC;
      white-space: nowrap;
      border-radius: 24px;
    }
    .active {
      color: #111111;
      font-weight: 500;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      background: #fff;
      border-radius: 24px;
    }
    .hidden {
      display: none;
    }
  }
  .count {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 68px;
    height: 36px;
    margin-right: 24px;
    margin-bottom: 22px;
    color: #999999;
    font-weight: 300;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 18px;
  }
}

.pop-wrapper {
  width: 100vw;
}
</style>

<template>
  <section>
    <div
      v-zpm="{
        sectionid: 101,
        areaexposure: 101
      }"
      class="banner-container"
    >
      <z-swipe
        ref="swipe"
        class="swiper-content"
        :initial-swipe="initialSwipe"
        :loop="false"
        :showCheckMore="true"
        checkMoreText="继续滑动查看验机报告"
        @change="bannerChange"
        @checkMore="checkMore"
      >
        <z-swipe-item v-for="(item, index) in swiperData.factImgs" :key="index">
          <!-- 轮播图状态 -->
          <div
            v-zpm="{
              sectionid: 101
            }"
            @click="checkBigImage(index)"
          >
            <!-- 轮播图首图采用渐进式加载 v-gradual是真实加载的图片 -->
            <img
              v-if="index == 0"
              v-zpm="{
                sortid: index,
                sortname: '轮播图点击',
                areaexposure: 101
              }"
              v-gradual="{ src: item }"
              :src="swiperData.preRenderImg"
              class="img-item"
              :class="{ 'image-item-pc': isPC }"
              alt=""
            />
            <img
              v-else
              v-zpm="{
                sortid: index,
                sortname: '轮播图点击',
                areaexposure: 101
              }"
              v-lazy="item"
              class="img-item"
              :class="{ 'image-item-pc': isPC }"
              alt=""
            />
          </div>
        </z-swipe-item>

        <template v-if="mainImageToolList && mainImageToolList.length">
          <!-- 口碑 -->
          <z-swipe-item
            v-if="
              indicatorGroup.find((item) => item.code == '1') &&
              (state.zcShowListData || state.rating)
            "
          >
            <Trust :mainImageToolList="mainImageToolList" />
          </z-swipe-item>

          <z-swipe-item v-if="indicatorGroup.find((item) => item.code == '2')">
            <!-- 配件 -->
            <Parts :mainImageToolList="mainImageToolList" @listenMatching="listenMatching" />
          </z-swipe-item>

          <z-swipe-item
            v-if="indicatorGroup.find((item) => item.code == '3') && dataInfo.wearingInfo"
          >
            <!-- 佩戴 -->
            <Wear :dataInfo="dataInfo" />
          </z-swipe-item>
        </template>

        <div
          v-show="indicatorGroup.length > 1"
          slot="indicator"
          v-zpm="{ sectionid: 102 }"
          class="custom-indicator"
        >
          <span
            v-for="(item, index) in indicatorGroup"
            :key="index"
            v-zpm="{ sortid: index, sortname: item.title }"
            :class="{
              active: activeGroup === index
            }"
            @click="changeGroup(index)"
            >{{ item.title }}
          </span>
        </div>
      </z-swipe>
      <!-- 只有实拍和细节展示滑动的图片位置和图片总数 -->
      <div v-show="showSwiperCount" v-if="indicatorGroup[activeGroup]" class="count">
        {{ currentShowValue }}/{{ indicatorGroup[activeGroup].total }}
      </div>
    </div>
  </section>
</template>

<script>
import { Swipe, SwipeItem, ImagePreview } from '@zz-common/zz-ui'
import { setPicSize } from '@zz-common/zz-utils'
import Vue from 'vue'
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  inject,
  nextTick
} from '@vue/composition-api'
// import PopPreview from './pop-preview'
import { previewImgClick } from '@utils/useBigImages'
import { loadFirstImage, getQueryString } from '@utils/index'
import { hasSupportFeature, isPlatform, browserLuxuryImages } from '@utils/native'
// TIPS: 待调试好质检报告需要需要
import native from '@zz-common/native-adapter'
import { exposureFeedback, getShowFeedback } from '@/apis/index'

import { getCheckBigImageList } from '@utils/checkBigImages'
import { setState, state } from '@/store'
import SmoothScroll from '@utils/smoothScroll'
import Trust from './trust' // 口碑
import Parts from './parts' // 配件
import Wear from './wear' // 佩戴效果
Vue.use(Swipe).use(SwipeItem).use(ImagePreview)
const isPC = !('ontouchstart' in window)
let smoothSroll = null
window.SmoothScroll = SmoothScroll

export default defineComponent({
  props: {
    bannerData: {
      type: [Array],
      default: () => {
        return []
      }
    },
    //原图
    originPics: {
      type: Array,
      default: () => []
    },
    //瑕疵图（pic1域名）
    detailDrawing: {
      type: [Array],
      default: () => {
        return []
      }
    },
    detailDrawingIds: {
      type: Object,
      default: () => {}
    },
    detailDrawingNewObj: {
      type: [Array],
      default: () => {
        return []
      }
    },
    mainImageToolList: {
      type: Array,
      default: () => {
        return []
      }
    },
    statusHeight: {
      type: Number,
      default: 0
    },
    //商品仓库地址
    warehouseInfo: {
      type: String,
      default: ''
    },
    // TODO: 二奢融合 商详类型
    infoType: {
      type: Number,
      default: 1
    },
    dataInfo: {
      type: Object,
      default: () => {}
    },
    // 质检信息
    reportItem: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Trust,
    Parts,
    Wear
  },
  setup(props, ctx) {
    const { $tiktok, $legoAreaExposure, $legoSend } = ctx.root
    console.log(props.dataInfo.showRedHubPicture, 'dataInfo')
    const video = ref(null)
    const swipe = ref(null)
    const pop = ref(null)
    const activeGroup = ref(0)
    const currentShowValue = ref(1)
    const initialSwipe = ref(0)
    const listenClickTab = inject('listenClickTab') || '' // 性价比解读点击事件
    const animating = ref(false)
    const offset = ref(0)
    const iconArrow = ref(
      'https://pic4.zhuanstatic.com/zhuanzh/c325332c-1eaa-44f5-b461-9943fecf0729.png'
    )
    //是否展示动态的百川反馈入口
    const showFeedback = ref(false)

    /**
     * $ 二奢质检报告数据
     */
    // TODO: 二奢融合 质检报告数据
    const luxuryReport = computed(() => {
      return props?.dataInfo?.luxuryReport
    })

    // 需要传入客户端的细节图数据
    const detailTopImgList = computed(() => {
      // 处理细节图数据
      const imgList = []
      const tabsList = luxuryReport.value?.productDefectInfoDTO?.defectInfos || []
      tabsList.forEach((item) => {
        const { leftDefectsData, rightDefectsData, position, zzPicUrl } = item
        // 由于存在多个细节图对应同一个实拍图的case 所以实拍图的数据也在这里处理
        getData(imgList, leftDefectsData, position, zzPicUrl)
        getData(imgList, rightDefectsData, position, zzPicUrl)
      })

      return imgList

      function getData(imgList, arr, position, pic) {
        arr
          .filter((item) => item.zzPicUrl)
          .forEach((img) => {
            const textDesc = img.conditionDesc && position ? position + '-' + img.conditionDesc : ''
            imgList.push({
              img: pic,
              poiX: img.poiX,
              poiY: img.poiY,
              textDesc,
              pic: img.zzPicUrl
            })
          })
      }
    })
    // 瑕疵图原图集合
    const originDrawImg = computed(() => {
      const { infoType = 1000 } = props?.dataInfo
      const detailDrawed = props?.detailDrawingNewObj.map((item) => item.url) || []
      const luxuryImgs = luxuryReport?.value?.badPics?.length ? luxuryReport?.value?.badPics : []
      return (infoType != 1000 ? luxuryImgs : detailDrawed) || []
    })

    // 实拍图+瑕疵图原图集合 用于h5展示
    const originImgList = computed(() => {
      const swipeImged = props?.originPics || []

      return [...swipeImged, ...originDrawImg.value]
    })

    /**
     * $ 细节图处理  兼容二奢逻辑
     */
    // TODO: 二奢融合
    const createDetailGroup = (title, subtitle, data, imgDataList, itemIds, id) => {
      return {
        title,
        subtitle,
        total: data.length,
        data,
        imgDataList,
        itemIds,
        id
      }
    }
    /**
     * $ 实拍图+瑕疵图原图集合 用于端内app展示
     */
    const indicatorGroup = computed(() => {
      const group = []
      // 实拍图原图 baseInfoMsg.picIds
      if (props.originPics?.length) {
        group.unshift({
          title: '实拍',
          subtitle: '概况',
          total: props.originPics.length,
          data: props.originPics,
          imgDataList: [],
          id: 0
        })
      }
      // 瑕疵图原图
      // TODO: 二奢融合 细节图处理
      const detailData =
        props.dataInfo?.infoType != 1000 ? luxuryReport?.value?.badPics : originDrawImg.value
      if (detailData && detailData.length) {
        const list = createDetailGroup(
          '细节',
          '细节',
          detailData,
          props.detailDrawingNewObj,
          props.detailDrawingIds,
          1
        )
        group.push(list)
      }

      // 口碑&搭配
      if (props.mainImageToolList && props.mainImageToolList.length) {
        const trust_parts = props.mainImageToolList.reduce((pre, cur) => {
          pre.push({
            title: cur.title,
            total: 1,
            code: cur.code
          })

          return pre
        }, [])
        group.push(...trust_parts)
      }

      // 轮播图底部按钮曝光 实拍|细节|口碑|搭配买
      group &&
        group.forEach((item) => {
          $legoSend({
            pagetype: 'Areaexposure',
            actiontype: 'T2974',
            backup: {
              sortName: item.title,
              sectionId: '102'
            }
          })
        })
      return group
    })

    watch(
      () => state.zcShowListData,
      (val) => {
        // TIPS: 保留 && props.dataInfo.infoType == 1000
        // 种草秀数量小于2 并且没有评价 此时不展示口碑
        if (val && Object.keys(val).length) {
          if (val.evaluationInfos.length < 2 && Object.keys(state.rating).length == 1) {
            const i = indicatorGroup.value.findIndex((item) => item.code == '1')
            if (i > 0) {
              indicatorGroup.value.splice(i, 1)
            }
          }
        }
      }
    )

    watch(
      () => state.rating,
      (val) => {
        // TIPS: 说明没有返回评价数据 保留 && props.dataInfo.infoType == 1000
        // 种草秀数量小于2 并且没有评价 此时不展示口碑
        if (Object.keys(val).length == 1 && state.zcShowListData.evaluationInfos.length == 0) {
          const i = indicatorGroup.value.findIndex((item) => item.code == '1')

          if (i > 0) {
            indicatorGroup.value.splice(i, 1)
          }
        }
      }
    )

    // 轮播图压缩图集合（pic1域名）
    const swiperData = computed(() => {
      const group = []
      if (props.bannerData.length) {
        group.unshift(...props.bannerData)
      }
      // TODO: 二奢融合 如果是二奢的商详 取二奢的细节图
      if (props.dataInfo.infoType !== 1000) {
        if (props.dataInfo?.luxuryReport?.badPics?.length) {
          group.push(...props.dataInfo.luxuryReport.badPics)
        }
      } else {
        if (props.bannerData.length && props.detailDrawing.length) {
          group.push(...props.detailDrawing)
        }
      }

      const factImgs = group.map((item) => setPicSize(item, 1000, 1000))
      console.log(factImgs, 'factImgs')
      //轮播图首图采用预渲染的方式加载
      const preRenderImg = setPicSize(group[0], 150, 150)
      return {
        factImgs,
        preRenderImg
      }
    })

    const showSwiperCount = computed(() => {
      return (
        indicatorGroup.value[activeGroup.value]?.id == 0 ||
        indicatorGroup.value[activeGroup.value]?.id == 1
      )
    })

    $tiktok('create', 'carousel')
    onMounted(() => {
      $tiktok('mounted', 'carousel')
      $legoAreaExposure()
      //接口延迟500毫秒调用，防止阻塞主接口
      setTimeout(() => {
        handleFeedback()
      }, 500)
    })

    function changeGroup(index) {
      console.log('index', index)
      if (activeGroup.value === index) return
      activeGroup.value = index
      currentShowValue.value = 1
      if (index === 0) {
        if (initialSwipe.value === index) {
          swipe.value.swipeTo(index)
        }
        initialSwipe.value = 0
      } else {
        let count = 0
        indicatorGroup.value.forEach((item, i) => {
          if (i < index) {
            count = count + item?.total || 0
          }
        })

        if (initialSwipe.value === count) {
          swipe.value.swipeTo(count)
        }
        initialSwipe.value = count
      }

      // 口碑和配件区域曝光
      const { code, title } = indicatorGroup.value[activeGroup.value]
      if (code) {
        $legoSend({
          pagetype: 'Areaexposure',
          actiontype: 'T2974',
          backup: {
            sortName: title,
            sectionId: code == '1' ? '161' : '162'
          }
        })
      }
    }

    function bannerChange(i) {
      let index = i
      const imgList = swiperData.value.factImgs
      if (index == imgList.length - 1) {
        index = 0
      }
      loadFirstImage(imgList[index + 1])
      calculatePosition(i)
    }

    function checkMore(x) {
      if (x > 0) return
      if (Math.abs(x) > 180) {
        $legoSend({
          pagetype: 'zpmclick',
          actiontype: 'T2974',
          backup: {
            sectionId: '101',
            sortId: '97',
            sortName: '继续滑动查看质检报告'
          }
        })
        changeRoute('qcreport')
      }
    }

    function closePreview({ url, index }) {
      console.log('url', url)
      if (isPlatform('zz')) {
        initialSwipe.value = index
      } else {
        swipe.value.swipeTo(index)
      }
      calculatePosition(index)
    }

    function calculatePosition(index) {
      const originalGroupIndex = activeGroup.value
      //计算active的分组
      let count = 0
      let end = false
      indicatorGroup.value.forEach((item, i) => {
        if (end) return
        if (index + 1 > count && index + 1 <= count + item.total) {
          activeGroup.value = i
          end = true
        }
        count = count + item.total
      })
      //计算active分组里的active位置
      if (activeGroup.value === 0) {
        currentShowValue.value = index + 1
      } else {
        let count = 0
        indicatorGroup.value.forEach((item, i) => {
          if (item.id == 0 || item.id == 1) {
            if (i === activeGroup.value) return
            count = count + item.total
          }
        })
        currentShowValue.value = index - count + 1
      }
      //分组改变了则需要改变initialSwipe的值，否则切换回去因为initialSwipe没变过导致不切换
      if (originalGroupIndex !== activeGroup.value) {
        setTimeout(() => {
          initialSwipe.value = index
        }, 0)
      }
      // 口碑和配件区域曝光
      const { code, title } = indicatorGroup.value[activeGroup.value]
      if (code) {
        $legoSend({
          pagetype: 'Areaexposure',
          actiontype: 'T2974',
          backup: {
            sortName: title,
            sectionId: code == '1' ? '161' : '162'
          }
        })
      }
    }
    // 百川反馈入口曝光
    async function handleExposureFeedback() {
      const infoId = getQueryString('infoId') || state.infoId
      const param = {
        questionnaireId: '1660928237036900352',
        componentType: 1,
        pageName: '商品大图',
        cateId: state.cateFirstId,
        infoId,
        type: 0
      }
      await exposureFeedback(param).catch((e) => {
        console.error(e)
      })
    }

    function sliceText(str) {
      const leftIndex = str.indexOf('<')
      if (leftIndex !== -1) {
        const text = str.slice(0, leftIndex)
        str = sub(str, leftIndex)
        return text
      }
    }

    function sliceHtml(str) {
      const leftIndex = str.indexOf('<')
      const rightIndex = str.indexOf('>')
      if (leftIndex !== -1 && rightIndex !== -1) {
        const text = str.slice(leftIndex, rightIndex + 1)
        str = sub(str, rightIndex + 1)
        return text
      }
    }

    function sub(str, substr) {
      return str.substr(substr.length)
    }

    /**
     * $ 二奢实拍图 细节图反馈
     */
    async function handleFeedback() {
      const infoId = getQueryString('infoId') || state.infoId
      try {
        const param = {
          questionnaireId: '1660928237036900352',
          componentType: 1,
          pageName: '商品大图',
          cateId: state.cateFirstId,
          infoId
        }
        const { data = {} } = await getShowFeedback(param)
        showFeedback.value = Boolean(data.questionnaireUrl)

        setState({
          showQuestionnaireUrl: showFeedback.value ? 1 : 0
        })
      } catch (e) {
        console.error(e)
      }
    }

    const createFeedbackUrl = () => {
      const questionnaireId = '1702591683343946240'
      const infoId = getQueryString('infoId') || state.infoId
      const { cateFirstId, title, infoLv, handPriceVo } = props.dataInfo
      const extend = {
        // 页面名称
        pageName: '奢侈品商品大图',
        // 品类
        pgCateId: cateFirstId,
        // 商品 id
        infoId,
        // 商品标题
        infoName: title || '',
        quality: infoLv?.level || '',
        price: (handPriceVo?.handPriceCent || 0) / 100
      }
      const jumpUrl = `https://m.zhuanzhuan.com/common/uem/index.html?questionnaireId=${questionnaireId}&extend=${encodeURIComponent(
        encodeURIComponent(JSON.stringify(extend))
      )}&needHideHead=3&wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.8#/question-bch`

      return jumpUrl
    }

    /**
     * $ 二奢融合 预览大图 实拍图+细节图
     */
    const onClick = (index) => {
      const jumpUrl = createFeedbackUrl()
      // TODO 检查异常情况
      // const { showRedHubPicture } = luxuryReport.value

      const imgDatalist = []
      detailTopImgList.value.forEach((item) => {
        imgDatalist.push({
          url: item.pic,
          flawTitle: item.textDesc
        })
      })

      // const tabList = []
      // tabList.push({
      //   name: '细节',
      //   // imgList: luxuryReport?.value?.badPics.map((item) => setPicSize(item, 1000, 1000)),
      //   imgDatalist,
      //   topImgList: detailTopImgList.value,
      //   actionButton: {
      //     text: '反馈',
      //     jumpUrl
      //   }
      // })
      // console.log(tabList, 'tabList')

      if (isPlatform('zz')) {
        // TIPS: 二奢质检报告跟B2C处理逻辑不一样，需要区分
        hasSupportFeature({ method: 'browserLuxuryImages' }, (res) => {
          if (res && res.code && res.code != '-1') {
            const tabList = []
            if (props.originPics?.length) {
              tabList.push({
                tabName: '概况',
                name: '实拍',
                imgList: props.originPics.map((item) => setPicSize(item, 1000, 1000)),
                actionButton: {
                  text: '反馈',
                  jumpUrl
                }
                // feedBack: {
                //   text: '实拍图对你有帮助吗？',
                //   btnText: '我要反馈',
                //   jumpUrl: ``
                // }
              })
            }

            if (luxuryReport?.value?.badPics?.length) {
              const imgDataList = []
              detailTopImgList.value.forEach((item) => {
                imgDataList.push({
                  url: item.pic,
                  flawTitle: item.textDesc
                })
              })
              if (props.dataInfo.showRedHubPicture) {
                tabList.push({
                  name: '细节',
                  // imgList: luxuryReport?.value?.badPics.map((item) => setPicSize(item, 1000, 1000)),
                  imgDataList,
                  topImgList: detailTopImgList.value,
                  actionButton: {
                    text: '反馈',
                    jumpUrl
                  }
                })
              } else {
                tabList.push({
                  name: '细节',
                  imgList: luxuryReport?.value?.badPics.map((item) => setPicSize(item, 1000, 1000)),
                  actionButton: {
                    text: '反馈',
                    jumpUrl
                  }
                })
              }
            }

            console.log(tabList, 'tabList')

            const goodsMsg = {
              goodsAddress: props.warehouseInfo || '',
              goodsNumber: props?.dataInfo?.luxuryReport?.qcCode
                ? `证书编号：${props?.dataInfo?.luxuryReport?.qcCode}`
                : ''
            }

            native.wrap('browserLuxuryImages')(
              {
                selectedIndex: index,
                tabList,
                ...goodsMsg
              },
              (res) => {
                if (res && !isNaN(res.position)) {
                  closePreview({ url: '', index: res.position })
                  // handleFeedback()
                }
              }
            )
          } else {
            usePreviewImgClick(index)
          }
        })
      } else {
        usePreviewImgClick(index)
      }
    }

    function checkBigImage(index) {
      if (isPC) {
        return
      }

      if (props.dataInfo.infoType != 1000) {
        onClick(index)
      } else {
        // usePreviewImgClick(index)
        // useBrowserLuxuryImages(index)
        // 在端内没视频并且browserLuxuryImages可用
        if (isPlatform('zz')) {
          hasSupportFeature({ method: 'browserLuxuryImages' }, (res) => {
            if (res && res.code && res.code != '-1') {
              // 百川曝光
              // state.showQuestionnaireUrl == 1 && handleExposureFeedback()
              showFeedback.value && handleExposureFeedback()
              useBrowserLuxuryImages(index)
            } else {
              usePreviewImgClick(index)
            }
          })
        } else {
          usePreviewImgClick(index)
        }
      }

      // TIPS: 暂时注释
      // usePreviewImgClick(index)
      // useBrowserLuxuryImages(index)
      // 在端内没视频并且browserLuxuryImages可用
      // if (isPlatform('zz')) {
      //   hasSupportFeature({ method: 'browserLuxuryImages' }, (res) => {
      //     if (res && res.code && res.code != '-1') {
      //       // 百川曝光
      //       // state.showQuestionnaireUrl == 1 && handleExposureFeedback()
      //       showFeedback.value && handleExposureFeedback()
      //       useBrowserLuxuryImages(index)
      //     } else {
      //       usePreviewImgClick(index)
      //     }
      //   })
      // } else {
      //   usePreviewImgClick(index)
      // }
      swiperData.value.factImgs.forEach((item) => {
        loadFirstImage(item)
      })
    }

    function useBrowserLuxuryImages(index) {
      // 查看大图只显示实拍图和细节图
      const renderIndicatorGroup = indicatorGroup.value.filter(
        (item) => item.id == 0 || item.id == 1
      )
      const bottomTips = []
      const tabList = getCheckBigImageList(renderIndicatorGroup)
      // alert(JSON.stringify(tabList))
      if (props.reportItem) {
        let { groupExplain = '' } = props.reportItem[0]

        if (groupExplain && groupExplain.indexOf('<') != -1) {
          let isBold = 0
          while (groupExplain) {
            // 截取字符串
            const leftText = sliceText(groupExplain)
            if (leftText) {
              bottomTips.push({
                isBold,
                text: leftText
              })
            }
            groupExplain = sub(groupExplain, leftText)
            const lHtml = sliceHtml(groupExplain)
            isBold = isBold === 1 ? 0 : 1
            groupExplain = sub(groupExplain, lHtml)
          }
        } else {
          bottomTips.push({
            isBold: 0,
            text: groupExplain
          })
        }
        tabList.forEach((item) => {
          item.bottomTips = bottomTips
        })
      }
      // 文案优先反馈展示
      tabList.forEach((item) => {
        if (item.bottomTips && item.bottomTips.length) {
          delete item.feedBack
        }
      })

      console.info('tabList', tabList)

      const goodsMsg = {
        goodsAddress: props.warehouseInfo || '',
        goodsNumber: state.qcCode
          ? `验机编码 ${state.qcCode || props?.dataInfo?.luxuryReport?.qcCode}`
          : ''
      }

      browserLuxuryImages(
        { selectedIndex: index, tabList, ...goodsMsg, needSlideCallback: 1, zpmPageId: 'T2974' },
        (res) => {
          if (res && !isNaN(res.position)) {
            closePreview({ url: '', index: res.position })
            handleFeedback()
          }
        }
      )
    }

    function usePreviewImgClick(currentIndex) {
      previewImgClick(originImgList.value, [], currentIndex, closePreview)
    }

    function pauseVideo() {
      usePreviewImgClick(0)
    }

    const watchHeaderChange = (statusHeight) => {
      nextTick(() => {
        let dom_height = 0
        if (isPlatform('zz')) {
          const _H = document.querySelector('.header-content')
          offset.value =
            (_H &&
              Math.ceil(Number(_H.clientHeight) + Number(_H.offsetTop) + Number(statusHeight))) ||
            0
        } else {
          dom_height = (80 / 750) * window.innerWidth
          offset.value = Math.ceil(Number(dom_height) + Number(statusHeight))
        }
        smoothSroll = new window.SmoothScroll('.nav-tab li', {
          offset: offset.value,
          updateURL: false
        })
      })
    }

    const changeRoute = (id) => {
      if (id === 'performance') {
        listenClickTab()
      } else {
        const elem = document.querySelector(`#tab-${id}`)
        elem && smoothSroll.animateScroll(elem)
      }
    }
    const listenMatching = (tabname, index) => {
      ctx.emit('listenMatching', tabname, index)
    }

    watch(
      () => props.statusHeight,
      () => {
        const statusHeight = props.statusHeight
        watchHeaderChange(statusHeight)
      },
      {
        deep: true,
        immediate: true
      }
    )

    return {
      swipe,
      video,
      pop,
      currentShowValue,
      bannerChange,
      checkBigImage,
      pauseVideo,
      activeGroup,
      indicatorGroup,
      changeGroup,
      initialSwipe,
      swiperData,
      isPC,
      state,
      animating,
      changeRoute,
      listenClickTab,
      iconArrow,
      checkMore,
      showSwiperCount,
      listenMatching,
      sliceText,
      sliceHtml,
      sub,
      detailTopImgList
    }
  }
})
</script>
